export function generateRandomString() {
  const uid = (Math.random() + 1).toString(36);
  return uid.substring(uid.indexOf('.') + 1);
}
